// extracted by mini-css-extract-plugin
export var showAll = "PostList-module--showAll--JphTd";
export var showLess = "PostList-module--showLess--+hWFw";
export var showMore = "PostList-module--showMore--L1WPz";
export var title = "PostList-module--title--G+AYu";